module.exports = __webpack_public_path__ + "static/23-f93d5b2bd0e998df9cf394cb713dd32f.png";